import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectAdjustmentSettings } from '../orderSelectors.ts';
import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectBelowGradeFullBathsAdj } from './selectBelowGradeFullBathsAdj.ts';
import { selectBelowGradeHalfBathsAdj } from './selectBelowGradeHalfBathsAdj.ts';
import { applyRoundingAndThresholds } from './utils/applyRoundingAndThresholds.ts';
import { getColorFromAdjustment } from './utils/getColorFromAdjustment.ts';
import { getStringValueFromAdjustment } from './utils/getStringValueFromAdjustment.ts';

const calculateBelowGradeBathsAdj = (
  fullBathsAdj: AloftPrice = AloftPrice.zero,
  halfBathsAdj: AloftPrice = AloftPrice.zero,
) => {
  return [fullBathsAdj, halfBathsAdj].reduce(
    (acc: AloftPrice, curr) => acc.add(curr),
    AloftPrice.zero,
  );
};

const selectBelowGradeBathsAdj = createPriceSelector(
  [selectBelowGradeFullBathsAdj, selectBelowGradeHalfBathsAdj],
  calculateBelowGradeBathsAdj,
);

const selectAppliedBelowGradeBathsAdj = createPriceSelector(
  [selectBelowGradeBathsAdj, selectAdjustmentSettings],
  (adj, adjSettings) => {
    if (isUndefined(adj)) {
      return undefined;
    }

    return applyRoundingAndThresholds(adj, 'bathBelowGrade', adjSettings);
  },
);

export const selectAppliedBelowGradeBathsAdjDisplay = createSelector(
  [selectAppliedBelowGradeBathsAdj],
  (adj) => {
    if (isUndefined(adj)) {
      return undefined;
    }

    return {
      value: getStringValueFromAdjustment(adj),
      color: getColorFromAdjustment(adj),
    };
  },
);
